export class DetalhamentoFaturaClienteConsulta {
  id: number;
  nomeConsulta: string;
  quantidade: string;
  valorUnitario: string;
  valorTotal: string;
  cortesia: boolean;

  constructor(detalhamentoFaturaClienteConsulta) {
    this.id = detalhamentoFaturaClienteConsulta["id"] || null;
    this.nomeConsulta =
      detalhamentoFaturaClienteConsulta["nomeConsulta"] || null;
    this.quantidade = detalhamentoFaturaClienteConsulta["quantidade"] || "0";

    // Formate valorUnitario e valorTotal no formato brasileiro com duas casas decimais
    if (
      detalhamentoFaturaClienteConsulta["valorUnitario"] !== undefined &&
      detalhamentoFaturaClienteConsulta["valorUnitario"] !== null
    ) {
      const valorUnitarioNumber = Number(
        detalhamentoFaturaClienteConsulta["valorUnitario"]
      );
      this.valorUnitario = valorUnitarioNumber.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      this.valorUnitario = "0.00";
    }

    if (
      detalhamentoFaturaClienteConsulta["valorTotal"] !== undefined &&
      detalhamentoFaturaClienteConsulta["valorTotal"] !== null
    ) {
      const valorTotalNumber = Number(
        detalhamentoFaturaClienteConsulta["valorTotal"]
      );
      this.valorTotal = valorTotalNumber.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      this.valorTotal = "0.00";
    }

    this.cortesia = detalhamentoFaturaClienteConsulta["cortesia"] || false;
  }
}
